import { components, services } from 'common';
import { bizComponents, bizServices } from 'businessCommon';
import { Button } from '@umu/umu-design';

const { isEnterpriseAccount } = bizServices;
const { Pagination, ClipBoardBtn } = bizComponents;
const { Breadcrumb, If, Loading, Checkbox, CustomDialog, Radiobox, AlertDialog } = components;
const { Toast } = services;

export {
    Breadcrumb,
    If,
    Loading,
    Checkbox,
    Button,
    CustomDialog,
    Radiobox,
    AlertDialog,
    Toast,
    Pagination,
    ClipBoardBtn,
    isEnterpriseAccount,
};

export interface IPageInfo {
    current_page: number;
    list_total_num: number;
    total_num?: number;
    size: number;
    total_page_num: number;
}
